export default __webpack_public_path__ + "static/media/no-promotions.82bcd791.svg";